export interface ISensorValue {
    sensorId: string;
    userId: string;
    deviceId: string;
    typeId: string;
    date: Date;
    value: number;
    unit?: string;
}

export interface ISensorData {
    typeId: string
    lastValueAt: Date
    unit: string
}

export interface ISensorDataExtended extends ISensorData {
    lastValue: number
    unit: string
}

export enum DeviceBrandId {
    //#region CHAMP
    WoePal = "9e62",
    WAQI = "8aaa",
    Flow = "105a",
    Fitbit = "1111",
    CapMedic = "tu76",
    //#endregion

    SakuraTech = "0ece",

    //#region A-IQ Ready
    inBiot = "0889",
    PolitoAndSAT = "ba11",
    //#endregion

    //#region SMILE
    AwarenessApp = "d521",
    DSS1 = "6be9",
    DSS2 = "4334",
    //#endregion

    //#region VETLLAR
    CEMIC = "720d",
    enControl = "3216",
    //#endregion

    //#region AURA
    Sykno = "fa41",
    //#endregion

    //#region ICARE
    Anura = "d02b",
    URVMINOS = "438d",
    //#endregion

    //#region COMPASS
    COMPASSApp = "e412",
    //#endregion

    //#region Open Wearables
    Garmin = "afb7",
    Polar = "f606",
    Suunto = "e27c",
    Whoop = "1015",
    Strava = "fce0",
    Oura = "08cc",
    FitbitOW = "0789",
    Ultrahuman = "5704",

    Apple = "cc10",
    Samsung = "e258",
    Google = "0b86",
    //#endregion
}

export enum DeviceBrandName {
    //#region CHAMP
    WoePal = "WoePal",
    WAQI = "WAQI",
    Flow = "Flow",
    Fitbit = "Fitbit",
    CapMedic = "CapMedic",
    //#endregion

    SakuraTech = "NVISION",

    //#region A-IQ Ready
    inBiot = "inBiot",
    PolitoAndSAT = "Polito and SAT",
    //#endregion

    //#region SMILE
    AwarenessApp = "Awareness App",
    DSS1 = "DSS1",
    DSS2 = "DSS2",
    //#endregion

    //#region VETLLAR
    CEMIC = "CEMIC",
    enControl = "enControl",
    //#endregion

    //#region AURA
    Sykno = "Sykno",
    //#endregion

    //#region ICARE
    Anura = "Anura",
    URVMINOS = "URV-MINOS",
    //#endregion

    //#region COMPASS
    COMPASSApp = "COMPASS App",
    //#endregion
}